import './index.erb';

import 'components/subproduct_landings/header';
import 'components/subproduct_landings/content';
import 'components/subproduct_landings/benefit';
import 'components/subproduct_landings/features';
import 'components/subproduct_landings/offer_section';
import 'components/subproduct_landings/contact';

(function () {
  'use strict';

  UserTracker.emit('pageVisited', {
    pageName: 'vestibular plan'
  });
})();
